import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { ProdutoListPage } from '../pages/produto-list/produto-list';
import { PedidoListPage } from '../pages/pedido-list/pedido-list';
import { PedidoFormPage } from '../pages/pedido-form/pedido-form';
import { PromocoesListPage } from '../pages/promocoes-list/promocoes-list';
import { FCM } from '@ionic-native/fcm';
import { SemovelProvider } from '../providers/semovel/semovel';
import { ReceitaListPage } from '../pages/receita-list/receita-list';
import { VideoListPage } from '../pages/video-list/video-list';
import { CarrinhoProvider } from '../providers/carrinho/carrinho';
import { ViewProvider } from '../providers/view/view';
import { LoginPage } from '../pages/login/login';
import { ProdutoViewPage } from '../pages/produto-view/produto-view';
import { DadosProvider } from '../providers/dados/dados';
import { EnderecoPage } from '../pages/endereco/endereco';
import { AcessoexternoProvider } from '../providers/acessoexterno/acessoexterno';
import { MeusDadosPage } from '../pages/meus-dados/meus-dados';
import { RegistroPage } from '../pages/registro/registro';
import { InstitucionalPage } from '../pages/institucional/institucional';
import { ConversaNutriListPage } from '../pages/conversa-nutri-list/conversa-nutri-list';
import { EnderecoListPage } from '../pages/endereco-list/endereco-list';
import { ContatoPage } from '../pages/contato/contato';
//import { Push, PushObject, PushOptions } from "@ionic-native/push";

@Component({ 
  templateUrl: 'app.html'
}) 
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;
  
  grupos: Array<any>;

  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, public fcm:FCM, public server:SemovelProvider,
    private eve:Events, public carrinho:CarrinhoProvider, private view:ViewProvider, private dadosP:DadosProvider, private acessoE:AcessoexternoProvider,
    /*public push: Push*/) {

    this.initializeApp();
    
    this.grupos = [];

    eve.subscribe("carrinho:adicionar", (produto, unidade) => {
      this.adicionar_carrinho(produto, unidade);
    });

    eve.subscribe("produto:ver", (produto) => {
      this.abrir_produto_view(produto);
    });

    eve.subscribe("aviso:produto", (produto) => {
      this.marcarAvise(produto);
    });

    eve.subscribe("home:grupos", (grupos) => {
      this.grupos = grupos;
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.dadosP.carregarCliente().subscribe(
        (cliente) => {
          this.eve.publish("carregar:cliente", cliente);
          this.carregarFirebase();
        }
      ) 
    });
  }

  carregarFirebase(){
    if(!this.platform.is('cordova')){
      return;
    }

    this.inicializeFireBaseCloudMesage();
    this.statusBar.styleDefault();
    this.splashScreen.hide();
  }

  inicializeFireBaseCloudMesage(){
    
    this.fcm.getToken().then(token => {
      this.dadosP.firebaseToken = token;
    });
    
    this.fcm.onNotification().subscribe((data) => {
      console.log(JSON.stringify(data));
      if(data.wasTapped){
        console.log("Received in background");
      } else {
        if(data.body){
          this.view.showMessage(data.body);
        }
      };
    });
    
    this.fcm.onTokenRefresh().subscribe(token => {
      this.dadosP.firebaseToken = token;
    });
  }

  // -------------------------------------  Eventos -------------------------------------------
  
  adicionar_carrinho(produto, unidade){

    if(!this.dadosP.getLogado()){
      this.view.showConfirm("Para criar um pedido é necessário fazer o <b>login</b>. Deseja realizar o login agora?", 
        () => {
          this.nav.setRoot(LoginPage);
        }
      );
      return;
      
    }

    // if(!this.dadosP.endereco){
    //   this.view.showConfirm("Para criar um pedido é necessário informar o <b>endereço</b>, Deseja cadastrar o endereço agora?", 
    //     () => {
    //       this.nav.push(EnderecoPage);
    //     }
    //   );
    //   return;
    // }

    this.carrinho.adicionar(produto, unidade);
    this.view.toast("Produto adicionado.")
  }

  abrir_produto_view(produto){
    this.nav.push(ProdutoViewPage, { produto: produto });
  }

  marcarAvise(produto){
    this.server.postData({method:"avive_me_produto"},{produto_id:produto.id}).subscribe(
      (mensagem) => {
        this.view.showMessage(mensagem);
      },
      (erro) => {
        this.view.showMessage("Não foi possível marcar o aviso no momento.");
      }
    );
  }

  abrirInicio(){
    this.nav.setRoot(HomePage);
  }
  
  abrirProdutos(){
    this.openPage(ProdutoListPage);  
  }
  
  abrirGrupo(grupo){
    this.eve.publish("home:abrirGrupo", grupo);
  }

  abrirCarrinho(){
    this.openPage(PedidoFormPage);  
  }
  abrirPedidos(){
    this.openPage(PedidoListPage);  
  }
  abrirPromocoes(){
    this.openPage(PromocoesListPage);  
  }

  //Opçoes do MENU
  openPage(page) {
    this.nav.push(page);
  }

  openInstagram(){
    this.acessoE.openInstagram();
  }

  entrarEmContato(){
    this.nav.push(ContatoPage);
  }

  openVideos() {
    this.nav.push(VideoListPage);
  }

  openReceitas() {
    this.nav.push(ReceitaListPage);
  }

  openEndereco() {
    this.nav.push(EnderecoListPage);
    // this.nav.push(EnderecoPage);
  }
  
  openDados() {
    this.nav.push(MeusDadosPage);
  }
  
  abrirQuemSomos(){
    this.nav.push(InstitucionalPage);
  }

  faleNutri(){
    this.nav.setRoot(ConversaNutriListPage);
  }

  sair() {
    this.view.showConfirm("Deseja sair do aplicativo? Caso tenha salvo seu acesso será solicitado a senha novamente.", () => {
      this.dadosP.setLogado(false);

      this.dadosP.limparSenha();

      this.nav.setRoot(LoginPage);
    })
  }
  
  abrirLogin(){
    this.nav.setRoot(LoginPage);
  }

  abrirCadastro(){
    this.nav.setRoot(RegistroPage);
  }

  faleNutriEnable(){
    return this.dadosP.faleNutri;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts